module.exports = __webpack_public_path__ + "static/media/quiz-hint-1-es-1080p.4dd1cd29.mp4";